import MailSend                                                                    from "../../../../domain/mail/send/MailSend";
import {
  ACTION_TYPE,
  MailSendAction,
  SetMailSendAction, SetMailSendContentAction,
  SetMailSendCustomersAction,
  SetMailSendGroupsAction, SetMailSendSubjectAction
} from "./MailSendAction";

const mailSendReducer = (state: MailSend = new MailSend(), action: MailSendAction): MailSend => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_MAIL_SEND:
      return (action as SetMailSendAction).mailSend;
    case ACTION_TYPE.SET_MAIL_SEND_GROUPS:
      return new MailSend((action as SetMailSendGroupsAction).mailGroups, state.customers, state.subject, state.content);
    case ACTION_TYPE.SET_MAIL_SEND_CUSTOMERS:
      return new MailSend(state.mailGroups, (action as SetMailSendCustomersAction).customers, state.subject, state.content);
    case ACTION_TYPE.SET_MAIL_SEND_SUBJECT:
      return new MailSend(state.mailGroups, state.customers, (action as SetMailSendSubjectAction).mailSendSubject, state.content);
    case ACTION_TYPE.SET_MAIL_SEND_CONTENT:
      return new MailSend(state.mailGroups, state.customers, state.subject, (action as SetMailSendContentAction).mailSendContent);
  }
};

export default mailSendReducer;